import ko from "knockout";

// Include the AMD template engine  (lightly adapted from https://github.com/rniemeyer/knockout-amd-helpers)
// And override the loader, to use webpack instead of RequireJS, per https://github.com/rniemeyer/knockout-amd-helpers/blob/master/examples/webpack/app.js
import "extensions/knockout.amdTemplateEngine";
ko.amdTemplateEngine.loader = function (templatePath, done) {
    done(require(`../${templatePath}.html`));
};

import multiSubscribe from "extensions/knockout.multiSubscribe";
import "lib/knockout.validation";
import "extensions/knockout.asyncComputed";
import "extensions/knockout.validation.extender";
import "extensions/i18n/knockout.i18n";

ko.multiSubscribe = multiSubscribe;

// This triggers KO to use native event handlers (`addEventListener`) instead of jQuery;
// we ran into a bug with our popover that were fixed by turning this on.
// This should be perfectly safe, since we don't support IE8.
ko.options.useOnlyNativeEvents = true;
ko.options.createChildContextWithAs = true;
ko.options.foreachHidesDestroyed = true;
